export default __webpack_public_path__ + "static/comp6-58af3d9cb98bc575b6e11220605b8a11.png";